
















import { Component, Prop, Mixins } from "vue-property-decorator";

import AppHeader from "@/components/AppHeader/AppHeader.vue";
import AppHeaderBackWithTitle from "@/components/AppHeader/AppHeaderBackWithTitle.vue";
import AppContent from "@/components/AppContent/AppContent.vue";
import ActivityBox from "@/components/ActivityBox/ActivityBox.vue";
import ActivityThumbnails from "@/components/ActivityThumbnails/ActivityThumbnails.vue";

import RequestState from "@/utils/mixins/RequestState";
import { LessonsFormData } from "./Lessons.vue";
import { ILesson, IActivity } from "@/models/interfaces/lessons";
import { ISchool } from "@/models/interfaces/schools";
import { IVuexState } from "@/models/interfaces/store";
import { IClass } from "@/models/interfaces/classes";

@Component({
  components: {
    AppHeader,
    AppHeaderBackWithTitle,
    ActivityThumbnails,
    AppContent,
    ActivityBox
  }
})
export default class LessonsStep21View extends Mixins(RequestState) {
  @Prop({ required: true })
  private lessonData!: IVuexState<{
    activities: IActivity[];
    lesson: ILesson;
  }>;

  private get lessonTitle() {
    const { data } = this.lessonData;

    if (data) {
      const { title } = data!.lesson;
      return `Lesson : ${title}`;
    } else {
      return "";
    }
  }

  private get sortedActivities() {
    return this.lessonData.data!.activities.sort((a, b) =>
      a.order > b.order ? 1 : -1
    );
  }
}
